/*///////////////////////////////
///jsonデータを振り分ける関数
///data:jsonデータ
///keyData:キー名
///////////////////////////////*/
function shopDetailHtml(data) {
  ///一旦リストを初期化
  $(".shop_detail_box,.breadcrumbs").empty();
    /////////jsonデータ出力箇所をhtmlテンプレートに登録
    let contents = data.contents;
    let shopBreadcrumbs ='<li><a href="/en/">TOP</a></li>\
    <li><a href="/en/event/">SHOP一覧</a></li>\
    <li>' + contents.shop_name + '</li>'

    let shopDetailHtml = '<div class="shop_ttl">\
    <div class="shop_logo">\
      <img src="/cms-img/shop/' + contents.logo_image + '" alt="' + contents.shop_name + '">\
    </div><!-- .shop_logo -->\
    <div class="shop_names">\
      <div class="shop_num">' + contents.contents + '</div>\
      <h2 class="shop_name">' + contents.shop_name + '</h2><!-- .shop_name -->\
      <p class="shop_ruby">' + contents.shop_phonetic + '</p><!-- .shop_ruby -->\
      <div class="shop_category">' + contents.category + '</div><!-- .category -->\
    </div><!-- .shop_names -->\
  </div><!-- .shop_ttl -->\
  <div class="shop_img">\
    <ul class="shop_slider">\
      <li><img src="/cms-img/shop/' + contents.image1 + '" alt=""></li>\
      <li><img src="/cms-img/shop/' + contents.image1 + '" alt=""></li>\
      <li><img src="/cms-img/shop/' + contents.image1 + '" alt=""></li>\
    </ul>\
  </div><!-- .shop_img -->\
  <div class="shop_text contents">\
    <p>' + contents.introduction + '</p>\
  </div><!-- .shop_text -->\
  <div class="info">\
    <dl class="info_table">\
      <dt>Hours</dt>\
      <dd>' + contents.work_time + '</dd>\
      <dt>Closed</dt>\
      <dd>' + contents.holiday + '</dd>\
      <dt>WEB</dt>\
      <dd class="link_blank"><a href="' + contents.link1_url + '">' + contents.link1_text + '</a></dd>\
      <dt>Accepted payment methods</dt>\
      <dd>' + contents.payment + '</dd>\
      <dt>Duty free services</dt>\
      <dd>' + contents.tax + '</dd>\
      <dt>Address</dt>\
      <dd>' + contents.postal + ' ' + contents.address + '</dd>\
      <dt>TEL</dt>\
      <dd><a href="tel:+81' + contents.postal + '">' + contents.postal + '</a></dd>\
    </dl>\
  </div>\
  <div class="related">\
    <h3>Related Link</h3>\
    <ul class="related_link">\
    <li class="link_blank link1_text"><a href="' + contents.link1_url + '" target="_blank">' + contents.link1_text + '</a></li>\
    <li class="link_blank link2_text"><a href="' + contents.link2_url + '" target="_blank">' + contents.link2_text + '</a></li>\
    </ul>\
  </div><!-- .related -->'
  shopDetailHtml = shopDetailHtml.replace(/\r?\n/g, '<br>');

  /////////jsonを出力したリストを表示させる
  $(shopBreadcrumbs).appendTo(".breadcrumbs").hide().fadeIn();
  $(shopDetailHtml).appendTo(".shop_detail_box").hide().fadeIn();
}
  
/*///////////////////////////////
///初期表示処理
///////////////////////////////*/
$(window).on('load',function() {
    //Ajaxに渡すデータ（初期値）
    //Ajax取得を行う
    $.ajax({
      url: ShopdetailJson,
      dataType:"json"
      })
      .done(function(data) {
        //成功した場合の処理
        shopDetailHtml(data);
        //箱の高さをそろえ
        // matchHeught();
        $('.shop_slider').slick({
          autoplay:true,
          autoplaySpeed:5000,
          slidesToShow:1,
          dots: true, // スライダー下部に表示される、ドット状のページネーションです
          infinite: true, // 無限ループ
          arrows: false,
        });
      })
      .fail(function(data) {
        //失敗した場合の処理
        $(".shop_detail_box").append("<p>データの取得に失敗しました。</p>");
    });
});

$(function() {
  ShopdetailJson = '/en/' +'module' + '/' +'json' + '/' +'shopdata_detail.json';
});
